import { Progress } from '@components/atoms/Progress'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@components/atoms/Tooltip'
import Icon from '@components/utils/Icon'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.impact_dashboard.progress')

type SessionProgressBarProps = {
  completedCount: number
  totalSupportersCount: number
  percentage: number
}

export function SessionProgressBar({ completedCount, totalSupportersCount, percentage }: SessionProgressBarProps) {
  const roundedPercentage = Math.round(percentage)

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <div className="tw:flex tw:items-center tw:justify-between">
        <div className="tw:flex tw:items-center tw:gap-1.5">
          <span className="tw:text-sm tw:font-medium tw:text-gray-900">
            {t('label', { completed: completedCount, total: totalSupportersCount })}
          </span>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button type="button" className="tw:inline-flex tw:items-center">
                  <Icon type="info-circle" className="tw:h-4 tw:w-4 tw:text-gray-900" />
                </button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{t('tooltip')}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <span className="tw:text-sm tw:font-medium tw:text-gray-900">{roundedPercentage}%</span>
      </div>
      <Progress
        value={percentage}
        className="tw:bg-white tw:h-2.5 tw:border-[0.5px] tw:border-primary-600"
        progressColor="tw:bg-purple-500 tw:rounded-[20px]"
      />
    </div>
  )
}
